import axios from "axios";

export const generatePDF = async ({ html, fileName, url }: { html?: string, fileName: string, url?: string }) => {
    const { data } = await axios.post<{ data: string }>(
        `/api/pdf`,
        { html, fileName, url }
    );

    return data.data;
}